// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="sep-22-2021">Sep 22, 2021</h3>
      <p>The Veteran Verification API v1.0.0 was updated to include a change to the /disability_rating endpoint response. The DisabilityRatingAttributes will now show date (2018-03-27) rather than datetime (2018-03-27T21:00:41.000+0000).</p>
      <p>This was introduced as a versioned change to allow API consumers to upgrade at their convenience. We encourage all consumers to migrate to the new version as v0.0.0 will be removed on December 1, 2021.<br />
      <a href="https://github.com/department-of-veterans-affairs/vets-api/pull/7546">View code changes(s)</a></p>
      <hr />
      <h3 id="aug-24-2021">Aug 24, 2021</h3>
      <p>The Veteran Verification API was updated to include more accurate Guard and Reserve Service data based on qualifying periods which is filtered to not include training or Title 32 service.</p>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/7685">View code changes(s)</a></p>
      <hr />
      <h3 id="june-10-2020">June 10, 2020</h3>
      <p>The optional query parameter <code>prompt</code> has been added to the authorization flow.</p>
      <ul>
      <li>Supported prompts: login. If specified, the user will be forced to provide credentials regardless of session state. If omitted, an existing active session with the identity provider may not require the user to provide credentials.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-saml-proxy/pull/111">View code changes(s)</a></p>
      <hr />
      <h3 id="may-11-2020">May 11, 2020</h3>
      <p>Added combined disability rating and individual disability ratings to the disability_rating endpoint.</p>
      <ul>
      <li><code>/disability_rating</code> endpoint: Adds <code>combined_disability_rating</code> field to responses. This is expressed as a percentage and represents how much a Veteran’s disability decreases their overall health and ability to function.</li>
      <li><code>/disability_rating</code> endpoint: Adds <code>individual_ratings</code> array to responses with each entry representing whether the individual condition is service related, when the Veteran could begin claiming benefits related to this disability, and the disability rating for the individual condition expressed as a percentage.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4223">View code changes(s)</a></p>
      <hr />
      <h3 id="april-15-2020">April 15, 2020</h3>
      <p>Added Veteran First &amp; Last Name to service_history endpoint.</p>
      <ul>
      <li><code>/service_history</code>: Adds <code>first_name</code> and <code>last_name</code> fields to responses.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4121">View code change(s)</a></p>
      <hr />
      <h3 id="march-18-2020">March 18, 2020</h3>
      <p>Added pay grade information to service_history endpoint.</p>
      <ul>
      <li><code>/service_history</code>: Adds <code>pay_grade_code</code> and <code>separation_reason</code> fields to responses.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-api/pull/4016">View code change(s)</a></p>
      <hr />
      <h3 id="november-8-2018">November 8, 2018</h3>
      <p>Launched the Disability Rating and Veteran Status endpoints</p>
      <ul>
      <li><code>/disability_rating</code>: Given an authenticated user, this created an endpoint that returns a Veteran's disability rating from VA</li>
      <li><code>/status</code>: Allows third-parties to request confirmation from the VA of an individual's Veteran status after receiving authorization to do so using an Open ID Connect flow.</li>
      </ul>
      <hr />
      <h3 id="june-11-2018">June 11, 2018</h3>
      <p>Launched the Service History endpoint</p>
      <ul>
      <li><code>/service_history</code>: Given an authenticated user, this created an endpoint that returns a Veteran's service history from VA</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
